import { combineReducers } from 'redux';
import { property as propertyCore } from '@breezeway/brzw-react-core';

export default combineReducers({
  loading: propertyCore.reducers.homeSummaryLoading,
  saving: propertyCore.reducers.saving,
  homeSummary: propertyCore.reducers.homeSummary,
  elements: propertyCore.reducers.elements,
  elementNotes: propertyCore.reducers.elementNotes,
  stats: propertyCore.reducers.homeSummaryStats,

  requirementSetList: propertyCore.reducers.requirementSetList,
  requirementSet: propertyCore.reducers.requirementSet,

  propertyTasksFilters: propertyCore.reducers.propertyTasksFilters,
});
